import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    root: {
      margin: "2rem auto 1rem auto",
      display: "flex",
      flexDirection: "column",
      gap: "0.25rem",
    },
  },
  { name: "LineItemGroupHeader" },
);

export default useStyles;
